<app-page-breadcrumb pageTitle="Equipos de chat" />

<div class="space-y-6">
  <div class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-gray-900">
    <div class="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
      <div>
        <h2 class="text-xl font-semibold text-gray-800 dark:text-white">Equipos de chat</h2>
        <p class="mt-1 max-w-2xl text-sm text-gray-500 dark:text-gray-400">
          Grupos de agentes que atienden las conversaciones del chat. Los modos de enrutamiento
          <span class="font-medium">Equipo específico</span>, <span class="font-medium">Turnos</span>,
          <span class="font-medium">Menor carga</span> y <span class="font-medium">Por idioma</span> asignan
          la conversación a un equipo, así que necesitan al menos uno creado.
        </p>
      </div>
      <button type="button" (click)="nuevo()"
        class="shrink-0 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-brand-600">
        + Nuevo equipo
      </button>
    </div>
  </div>

  @if (error) {
    <div class="rounded-xl border border-error-200 bg-error-50 p-4 dark:border-error-500/20 dark:bg-error-500/10">
      <p class="text-sm text-error-600 dark:text-error-400">{{ error }}</p>
    </div>
  }

  <div class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-gray-900">
    <div class="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <input type="text" [(ngModel)]="filtroNombre" (ngModelChange)="aplicarFiltros()"
        placeholder="Buscar por nombre…"
        class="w-full max-w-sm rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 focus:border-brand-500 focus:outline-none dark:border-gray-700 dark:bg-gray-800 dark:text-white" />
      <label class="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-300">
        <input type="checkbox" [(ngModel)]="filtroSoloActivos" (ngModelChange)="aplicarFiltros()"
          class="rounded border-gray-300 dark:border-gray-600" />
        Solo activos
      </label>
    </div>

    @if (loading) {
      <p class="py-10 text-center text-sm text-gray-400">Cargando equipos…</p>
    } @else if (filtered.length === 0) {
      <div class="rounded-xl border border-dashed border-gray-300 py-12 text-center dark:border-gray-700">
        <p class="text-sm text-gray-500 dark:text-gray-400">
          {{ items.length === 0 ? 'Todavía no hay equipos de chat.' : 'Ningún equipo coincide con el filtro.' }}
        </p>
        @if (items.length === 0) {
          <p class="mx-auto mt-1 max-w-md text-xs text-gray-400">
            Crea uno y agrégale agentes para poder usar los modos de enrutamiento por equipo.
          </p>
          <button type="button" (click)="nuevo()"
            class="mt-4 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-brand-600">
            Crear el primer equipo
          </button>
        }
      </div>
    } @else {
      <div class="overflow-x-auto">
        <table class="w-full text-sm">
          <thead>
            <tr class="border-b border-gray-200 text-left text-xs text-gray-500 dark:border-gray-700 dark:text-gray-400">
              <th class="pb-2 pr-4 font-medium">Equipo</th>
              <th class="pb-2 pr-4 font-medium">Idioma</th>
              <th class="pb-2 pr-4 font-medium">Miembros</th>
              <th class="pb-2 pr-4 font-medium">Estado</th>
              <th class="pb-2 font-medium text-right">Acciones</th>
            </tr>
          </thead>
          <tbody>
            @for (item of filtered; track item.id) {
              <tr class="border-b border-gray-100 last:border-0 dark:border-gray-800">
                <td class="py-3 pr-4">
                  <button type="button" (click)="verMiembros(item)"
                    class="text-left font-medium text-gray-800 hover:text-brand-600 dark:text-gray-100 dark:hover:text-brand-400">
                    {{ item.name }}
                  </button>
                  @if (item.description) {
                    <p class="mt-0.5 text-xs text-gray-500 dark:text-gray-400">{{ item.description }}</p>
                  }
                </td>
                <td class="py-3 pr-4 text-gray-600 dark:text-gray-300">{{ item.defaultLanguage || '—' }}</td>
                <td class="py-3 pr-4 text-gray-600 dark:text-gray-300">
                  @if (item.memberCount === 0) {
                    <span class="text-warning-600 dark:text-warning-400">Sin miembros</span>
                  } @else {
                    {{ item.activeMemberCount }} de {{ item.memberCount }} {{ item.memberCount === 1 ? 'activo' : 'activos' }}
                  }
                </td>
                <td class="py-3 pr-4">
                  <span class="rounded-full px-2.5 py-0.5 text-[11px] font-semibold"
                    [class.bg-success-50]="item.active" [class.text-success-700]="item.active"
                    [class.dark:bg-success-500/10]="item.active" [class.dark:text-success-400]="item.active"
                    [class.bg-gray-100]="!item.active" [class.text-gray-500]="!item.active"
                    [class.dark:bg-gray-800]="!item.active" [class.dark:text-gray-400]="!item.active">
                    {{ item.active ? 'Activo' : 'Inactivo' }}
                  </span>
                </td>
                <td class="py-3">
                  <div class="flex justify-end gap-2">
                    <button type="button" (click)="verMiembros(item)"
                      class="rounded-lg bg-gray-100 px-3 py-1.5 text-xs font-medium text-gray-700 transition-colors hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700">
                      Miembros
                    </button>
                    <button type="button" (click)="editar(item)"
                      class="rounded-lg bg-brand-50 px-3 py-1.5 text-xs font-medium text-brand-600 transition-colors hover:bg-brand-100 dark:bg-brand-500/10 dark:text-brand-400 dark:hover:bg-brand-500/20">
                      Editar
                    </button>
                    <button type="button" (click)="toggleActivo(item)"
                      class="rounded-lg border border-gray-300 px-3 py-1.5 text-xs font-medium text-gray-700 transition-colors hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
                      {{ item.active ? 'Desactivar' : 'Activar' }}
                    </button>
                    <button type="button" (click)="eliminar(item)"
                      class="rounded-lg bg-error-50 px-3 py-1.5 text-xs font-medium text-error-700 transition-colors hover:bg-error-100 dark:bg-error-500/10 dark:text-error-400 dark:hover:bg-error-500/20">
                      Eliminar
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>

  <button type="button" (click)="volverAChatflows()"
    class="text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-brand-400">
    ← Volver a Chatflows
  </button>
</div>
